/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const Router = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.81121 5.65457C5.27698 5.65457 5.65457 5.27698 5.65457 4.81121C5.65457 4.34543 5.27698 3.96784 4.81121 3.96784C4.34543 3.96784 3.96784 4.34543 3.96784 4.81121C3.96784 5.27698 4.34543 5.65457 4.81121 5.65457Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.81121 2C3.25862 2 2 3.25862 2 4.81121V7.2531C2 7.99868 2.29618 8.71372 2.82338 9.24093L6.75907 13.1766C7.85692 14.2745 9.63687 14.2745 10.7347 13.1766L13.1766 10.7347C14.2745 9.63687 14.2745 7.85692 13.1766 6.75907L9.24093 2.82338C8.71372 2.29618 7.99868 2 7.2531 2H4.81121ZM3.12448 4.81121C3.12448 3.87965 3.87965 3.12448 4.81121 3.12448H7.2531C7.70045 3.12448 8.12948 3.30219 8.4458 3.61851L12.3815 7.5542C13.0402 8.21291 13.0402 9.28088 12.3815 9.93959L9.93959 12.3815C9.28088 13.0402 8.21291 13.0402 7.5542 12.3815L3.61851 8.4458C3.30219 8.12948 3.12448 7.70045 3.12448 7.2531V4.81121Z"
        fill={props.fill || "#ED0037"}
      />
      <path
        d="M9.59026 6.21681H8.32522V5.65457H7.48185V6.21681H7.06017C6.51677 6.21681 6.07625 6.65733 6.07625 7.20073V7.34129C6.07625 7.8847 6.51677 8.32522 7.06017 8.32522H8.7469C8.82453 8.32522 8.88746 8.38815 8.88746 8.46578V8.60634C8.88746 8.68397 8.82453 8.7469 8.7469 8.7469H6.21681V9.59026H7.48185V10.1525H8.32522V9.59026H8.7469C9.2903 9.59026 9.73082 9.14974 9.73082 8.60634V8.46578C9.73082 7.92237 9.2903 7.48185 8.7469 7.48185H7.06017C6.98254 7.48185 6.91961 7.41892 6.91961 7.34129V7.20073C6.91961 7.1231 6.98254 7.06017 7.06017 7.06017H9.59026V6.21681Z"
        fill={props.fill || "#ED0037"}
      />
    </svg>
  );
};

Router.displayName = "Router";

export default Router;
